module.exports = __webpack_public_path__ + "img/slide-4-en.88c83e89.png";